import { FireRiskEnum } from '../../../../@core/fire-risk-dashboard/domain/enum/FireRisk.enum'

export class FarmRiskChartPlotBandsFactory {
	static make(risk: FireRiskEnum) {
		if (risk === FireRiskEnum.NONE) {
			return [
				{
					from: 0,
					to: 100,
					color: '#D3D3D3',
					thickness: 40,
					borderRadius: 0,
				},
			]
		}

		return [
			{
				from: 0,
				to: 20,
				color: '#009E27',
				thickness: risk === FireRiskEnum.NULL ? 110 : 40,
				borderRadius: 0,
			},
			{
				from: 20,
				to: 40,
				color: '#A2D800',
				thickness: risk === FireRiskEnum.SMALL ? 110 : 40,
				borderRadius: 20,
			},
			{
				from: 40,
				to: 60,
				color: '#FFD800',
				thickness: risk === FireRiskEnum.MEDIUM ? 110 : 40,
				borderRadius: 20,
			},
			{
				from: 60,
				to: 80,
				color: '#FF7C36',
				thickness: risk === FireRiskEnum.HIGH ? 110 : 40,
				borderRadius: 0,
			},
			{
				from: 80,
				to: 100,
				color: '#CE1619',
				thickness: risk === FireRiskEnum.HIGHEST ? 110 : 40,
				borderRadius: 0,
			},
		]
	}
}
